export function patchBigInt() {
  BigInt.prototype.toJSON = function () {
    return this.toString();
  };
}
